import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Divider, IconButton, ListItem, ListItemText, Stack, Tooltip, Typography} from "@mui/material";

const DraggableItem = (props) => {

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({id: props.id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    const secondaryAction = () => {
        if (props.action !== undefined && props.action.type === 'button'){
            return <Tooltip title={props.action.tooltip}>
                <IconButton edge="end" aria-label="products" onClick={props.action.onClick}>
                    {props.action.icon}
                </IconButton>
            </Tooltip>
        }
        if (props.action !== undefined && props.action.type === 'text')
        {
            return <Typography variant='body1'>{props.action.text}</Typography>
        }
    }


    return (
        <>
            <ListItem
                secondaryAction={secondaryAction()}
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
                sx={{cursor: 'grab'}}
            >
                {/*<ListItemText primary={props.item.title} secondary={props.item.description} />*/}
                <Stack direction='row' alignItems='center' mr={2} sx={{ minWidth: 0 }} gap={2}>
                    <Typography variant='h6'>{props.item.title}</Typography>
                    <Typography variant='body1' color='grey' noWrap>{props.item.subtitle}</Typography>
                </Stack>
            </ListItem>
            <Divider variant="fullWidth" component="li" />
        </>
    );
}

export default DraggableItem;